<template>
    <div>
        <b-modal
                id="calculatorModal"
                title-html="<i class='fa fa-calculator'></i>&nbsp;&nbsp;Rekenhulp"
                size="lg"
                :visible="open"
                ok-title="Neem gegevens over"
                ok-variant="success"
                @ok="calculatorCopyData"
                cancel-title="Annuleren"
                cancel-variant="danger"
                @cancel="calculatorClose"
                @close="calculatorEmitClose"
                @hide="calculatorEmitClose"
        >
            <b-row>
                <b-col>
                    <p>
                        Met deze rekenhulp maakt u een schatting van uw jaarinkomen. Beantwoord de vragen zo zorgvuldig mogelijk. Want de hoogte van uw inkomen bepaalt op welke woningen u mag reageren. Vraag bij twijfel aan uw werkgever of uitkeringsinstantie na hoe hoog uw inkomen is.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="5" class="form-label">
                    <label for="bruto">Loon voor loonheffing</label>
                </b-col>
                <b-col cols="1" sm="1" class="calculatorIconEuro">
                    <i class="fa fax fa-euro-sign"></i>
                </b-col>
                <b-col sm="4" cols="5">
                    <b-form-input
                            type="number"
                            min="0"
                            step="1"
                            id="bruto"
                            v-model="bruto"
                            size="sm"
                            placeholder=""
                            @keyup="calculatorDoMath"
                    />
                </b-col>
                <b-col sm="2" cols="5">
                    <b-form-select
                        v-model="bruto_interval"
                        :options="formData.interval"
                        @input="calculatorDoMath"
                    />
                </b-col>
            </b-row>

<!--papy Added these radio_Btns -->
<b-row>
    <b-col sm="5" class="form-label">
        <label for="incomeIndex">Loongegevens komen uit</label>
    </b-col>
  <!---
    <b-col sm="5">
        <b-form-radio-group id="checkbox-incomeIndex" v-model="incomeIndex" @input="calculatorDoMath">
            <b-form-radio :value="1">{{ T1.year }}</b-form-radio>
            <b-form-radio :value="T1.value ? T1.value : 1">{{T1.year - 1 }}</b-form-radio>
            <b-form-radio :value="T1.value && T2.value ? T1.value * T2.value : 1">{{ T1.year - 2 }}</b-form-radio>
        </b-form-radio-group>
    </b-col>
    --->
    
    <b-col sm="5">
    <b-form-radio-group id="checkbox-incomeIndex" v-model="incomeIndex" @input="calculatorDoMath">
        <template v-if="T1.year">
            <b-form-radio :value="1">{{ T1.year }}</b-form-radio>
            <b-form-radio :value="T1.value ? T1.value : 1">{{ T1.year - 1 }}</b-form-radio>
            <b-form-radio :value="T1.value && T2.value ? T1.value * T2.value : 1">{{ T1.year - 2 }}</b-form-radio>
        </template>
        <template v-else>
            <b-form-radio :value="1">{{ new Date().getFullYear() }}</b-form-radio>
        </template>
    </b-form-radio-group>
</b-col>

</b-row>


            <b-row>
                <b-col sm="5" class="form-label">
                    <label for="vacation">Ontvangt u vakantiegeld?</label>
                </b-col>
                <b-col sm="5">
                    <b-form-radio-group id="checkbox-vacation" v-model="vacation" @input="calculatorDoMath">
                        <b-form-radio :value="true">Ja</b-form-radio>
                        <b-form-radio :value="false">Nee</b-form-radio>
                    </b-form-radio-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="5" class="form-label">
                    <label for="vacation">Krijgt u een 13e maand?</label>
                </b-col>
                <b-col sm="5">
                    <b-form-radio-group id="checkbox-extraMonth" v-model="extraMonth" @input="calculatorDoMath">
                        <b-form-radio :value="true">Ja</b-form-radio>
                        <b-form-radio :value="false">Nee</b-form-radio>
                    </b-form-radio-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="5" class="form-label">
                    <label for="vacation">Ontvangt u partneralimentatie?</label>
                </b-col>
                <b-col sm="5">
                    <b-form-radio-group id="checkbox-alimony" v-model="alimony" @input="calculatorDoMath">
                        <b-form-radio :value="true">Ja</b-form-radio>
                        <b-form-radio :value="false">Nee</b-form-radio>
                    </b-form-radio-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1" sm="1" offset-sm="5" v-if="alimony" class="calculatorIconEuro">
                    <i class="fa fax fa-euro-sign"></i>
                </b-col>
                <b-col cols="5" sm="4" v-if="alimony">
                    <b-form-input
                            type="number"
                            min="0"
                            step="1"
                            id="alimony_count"
                            v-model="alimony_count"
                            size="sm"
                            placeholder=""
                            @keyup="calculatorDoMath"
                    />
                </b-col>
                <b-col cols="5" sm="2" v-if="alimony">
                    <b-form-select
                            v-model="alimony_interval"
                            :options="formData.interval"
                            @input="calculatorDoMath"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col class="spacer"></b-col>
            </b-row>
            <b-row>
                <b-col cols="10" offset="1" sm="8" offset-sm="2">
                    <b-card>
                        <b-card-body class="text-center">
                            <h2>
                                Uw inkomen per jaar:
                            </h2>
                            <h3>
                                <strong>
                                    <i>
                                        &euro; {{total}}
                                    </i>
                                </strong>
                            </h3>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
  export default {
    name: 'IncomeCalculator',

    props: [
      'open'
    ],
    data: () => {
      return {
        total: 0,
        bruto: 0,
        bruto_interval: 'month',
        incomeIndex:1,
        vacation: true,
        extraMonth: false,
        alimony: false,
        alimony_count: 0,
        alimony_interval: 'month',
        formData: {
          interval: [{ text: 'Jaar', value: 'year' },{ text: 'Maand', value: 'month' },{ text: '4 weken', value: 'fourweeks' },{ text: 'Week', value: 'week' }]
        }
      }
    },
    mounted() {
      fetchIncomeIndex();
    },

  activated () {
    this.fetchIncomeIndex();
  },

    methods: {

fetchIncomeIndex() {
  // Papy added and Called this Endpoint.
  this.loading = true;
  const self = this; 

  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  };

  this.$http
    .fetch(`${process.env.VUE_APP_API_URL}/indexeringspercentages`, options)
    .then(response => response.json())
    .then(result => {
      // Check if the properties exist before assigning
      if (result && result.hasOwnProperty('IDX_T-1') && result.hasOwnProperty('IDX_T-2')) {
        self.T1 = result['IDX_T-1']; // Corrected property access with square brackets
        self.T2 = result['IDX_T-2']; // Corrected property access with square brackets
      } else {
        console.error('Result properties IDX_T-1 or IDX_T-2 not found.');
      }
    })
    .catch(err => {
      console.error('Fetch Error:', err);
    })
    .finally(() => {
      this.loading = false;
    });
},


      calculatorDoMath() {
        let subtotal = 0;
        let bruto = isNaN(parseFloat(this.bruto)) ? 0 : parseFloat(this.bruto)
        /*papy added the indexIncome*/
        let incomeIdx = isNaN(parseFloat(this.incomeIndex)) ? 1 : parseFloat(this.incomeIndex)
        let alimony = isNaN(parseFloat(this.alimony_count)) ? 0 : parseFloat(this.alimony_count)
        if(this.bruto_interval === 'month') {
          subtotal = bruto * 12 * incomeIdx
        } else if(this.bruto_interval === 'fourweeks') {
          subtotal = bruto * 13 * incomeIdx
        } else if(this.bruto_interval === 'week') {
          subtotal = bruto * 52 * incomeIdx
        }else if(this.bruto_interval === 'year') {
          subtotal = bruto * 1 * incomeIdx
        }
        if(this.extraMonth) {
          subtotal = subtotal / 12 * 13 
        }
        if(this.vacation) {
          subtotal = subtotal * 1.08 
        }
        if(this.alimony) {
          if(this.alimony_interval === 'month') {
            subtotal = subtotal + ( alimony * 12 )
          } else if(this.alimony_interval === 'fourweeks') {
            subtotal = subtotal + ( alimony * 13 )
          } else if(this.alimony_interval === 'week') {
            subtotal = subtotal + ( alimony * 52 )
          } else if(this.alimony_interval === 'year') {
            subtotal = subtotal + ( alimony * 1 )
          }
        }

        this.total = Math.floor(subtotal)
      },
      calculatorClose() {
        this.$bvModal.hide('calculatorModal')
        this.calculatorEmitClose()
      },
      calculatorCopyData() {
        this.$emit('calculatorEmitVal', this.total);
        this.calculatorClose()
      },
      calculatorEmitClose() {
        this.$emit('calculatorClosed', 'empty');
      }
    }
  }
</script>

<style scoped>

</style>
